import { render } from "./AddEditTask.vue?vue&type=template&id=382deeb5&scoped=true"
import script from "./AddEditTask.vue?vue&type=script&lang=js"
export * from "./AddEditTask.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./AddEditTask.vue?vue&type=style&index=1&id=382deeb5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382deeb5"]])

export default __exports__